// Components==============
import Button from 'components/UI/Button/Button';
import Modal from 'components/UI/Modal/Modal';
import UploadProfileImage from 'components/UI/UploadProfileImage/UploadProfileImage';
import { useRedux } from 'hooks/useRedux';
import { useTranslate } from 'hooks/useTranslate';
import React from 'react';
import './UploadImageModal.module.scss';
// =========================

export default function UploadImageModal({
  setModalIsOpen,
  setAddMemberModalIsOpen,
}: {
  setModalIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setAddMemberModalIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) {
  const translate = useTranslate();

  const user = useRedux((state) => state.authentication?.user);

  const hasAvatar = user?.avatar_url && user?.avatar_url?.length > 1;

  return (
    <Modal size="medium" setModalIsOpen={setModalIsOpen}>
      <div styleName="wrapper">
        <UploadProfileImage />
        <h2>
          {translate(
            `${
              hasAvatar
                ? 'project.groupswork-popups.owner-image-popup.title2'
                : 'project.groupswork-popups.owner-image-popup.title1'
            }`
          )}
        </h2>
        <p>
          {translate(
            `${
              hasAvatar
                ? 'project.groupswork-popups.owner-image-popup.description2'
                : 'project.groupswork-popups.owner-image-popup.description1'
            }`
          )}
        </p>
        <div styleName="button-wrapper">
          <Button color="grey" onClick={() => setModalIsOpen(false)}>
            {translate('general.terms.cancel')}
          </Button>
          <Button
            onClick={() => {
              setModalIsOpen(false);
              setAddMemberModalIsOpen(true);
            }}
            inactive={!hasAvatar}
          >
            {translate(
              'project.groupswork-popups.owner-image-popup.invite-people'
            )}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
